import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJiraSoftware = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "24px",
	height: "24px",
	viewBox: "0 0 73.27 75.76",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#5e6c84;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}" }),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "linear-gradient",
				x1: 34.64,
				y1: 15.35,
				x2: 19,
				y2: 30.99,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .18,
					stopColor: "#344563"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#5e6c84"
				})]
			}),
			/* @__PURE__ */ _jsx("linearGradient", {
				id: "linear-gradient-2",
				x1: 38.78,
				y1: 60.28,
				x2: 54.39,
				y2: 44.67,
				xlinkHref: "#linear-gradient"
			})
		] }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			"data-name": "Layer 2",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Blue",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "cls-1",
						d: "M72.4,35.76,39.8,3.16,36.64,0h0L12.1,24.54h0L.88,35.76A3,3,0,0,0,.88,40L23.3,62.42,36.64,75.76,61.18,51.22l.38-.38L72.4,40A3,3,0,0,0,72.4,35.76ZM36.64,49.08l-11.2-11.2,11.2-11.2,11.2,11.2Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-2",
						d: "M36.64,26.68A18.86,18.86,0,0,1,36.56.09L12.05,24.59,25.39,37.93,36.64,26.68Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "cls-3",
						d: "M47.87,37.85,36.64,49.08a18.86,18.86,0,0,1,0,26.68h0L61.21,51.19Z"
					})
				]
			})
		})
	]
});
export default SvgJiraSoftware;
